module.exports = __webpack_public_path__ + "img/ic_close_small.6fb334f2.svg";